const locale = {
    placeholder: 'Odaberite vrijeme',
    rangePlaceholder: ['Vrijeme početka', 'Vrijeme završetka'],
};
export default locale;
